<template>
  <div id="popup"
       @focus="handleFocus"
       @focusout="handleFocusOut"
       tabindex="0"
       ref="frame"
       v-if="isSidebarActiveLocal" :class="isSidebarActiveLocal ? 'active' : ''">

    <div class="popup-cont">
      <h2 class="popup-heading">{{dataProp ? 'Save' : 'ADD NEW'}} EVENT</h2>
      <div class="popup-item">
        <h4>Event Title</h4>
        <input type="text" class="pop-input" v-model="title" placeholder="Title" name="Title" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
      </div>
      <div class="popup-item">
        <h4>Event Body</h4>
        <textarea class="pop-textarea" placeholder="Body" name="Body"  v-validate="'required'" v-model="body"></textarea>
        <span class="text-danger text-sm" v-show="errors.has('Body')">{{ errors.first('Body') }}</span>
      </div>
      <div class="popup-item">
        <h4>Restaurants</h4>
        <multiselect name="Restaurants" v-validate="'required'" v-model="selected_restaurants"
                     label="label" track-by="label" :multiple="true"
                     :options="multi_select_options">
        </multiselect>
        <span class="text-danger text-sm" v-show="errors.has('Restaurants')">{{ errors.first('Restaurants') }}</span>
      </div>
      <div class="popup-item">
        <div class="tr-button blue-button popup-button" @click="submitData">{{dataProp ? 'Save' : 'Add New'}} Event</div>
        <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    dataProp: {
      type: Object
    },
    end: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      title: '',
      body: '',
      id: null,
      restaurants: [],
      selected_restaurants: []
    }
  },
  mounted () {
    if (!this.restaurantlist) {
      this.getUserList()
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) {
        return
      } else if (this.dataProp) {
        const { id, title, body, restaurants } = JSON.parse(JSON.stringify(this.dataProp))
        this.id = id
        this.title = title
        this.body = body
        this.restaurants = restaurants
        this.selected_restaurants = this.restaurants.map(restaurant => {
          return  {
            label: restaurant.restaurant.user_property['Restaurant-Name'],
            value: restaurant.restaurant.id
          }
        })
      }
      return true
    }
  },
  computed: {
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }
      }
      return obj
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    restaurant_select () {
      return this.restaurantlist.map(restaurant => {
        return  {
          label: restaurant.user_property['Restaurant-Name'],
          value: restaurant.id
        }
      })
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlist || JSON.parse(localStorage.getItem('restaurantlist'))
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    multi_select_options () {
      return this.restaurantlist.map(user => {
        const option = {
          label: user.user_property['Restaurant-Name'],
          value: user.id
        }
        return option
      })
    }
  },
  methods: {
    handleFocus () {
      // do something here
    },
    handleFocusOut () {
      // do something here
    },
    initValues () {
      this.title = ''
      this.body = ''
      this.restaurants = []
      this.selected_restaurants = []
      this.id = null
    },

    getUserList () {
      const payload = {
        user_group: 2
      }

      this.$vs.loading()

      this.$store.dispatch('api/getUserList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const obj = {
            title: this.title,
            body: this.body,
            id: this.id,
            restaurants: this.selected_restaurants.map(rest => rest.value)
          }

          this.$store.dispatch('api/addEvent', obj).then((response) => {
            this.$vs.notify({
              title: 'Event Saved',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$vs.loading.close()
            this.isSidebarActiveLocal = false
          }).catch(err => {
            console.error(err)
            if (err.message.contains('Event saved')) {
              this.$vs.notify({
                title: 'Content Saved',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
            } else {
              this.$vs.notify({
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            }
            this.$vs.loading.close()
          })

        }
      })
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
  .popup-cont {
    height: auto !important;
    overflow: auto;

    .popup-item {
      .upload-image {

        max-height: 30vh;
        overflow: auto;
      }
    }
  }
</style>
